import StatusBar from "@portal/components/atoms/statusBar";
import NavBar from "../../NavBar";
import { TextResources } from "@portal/assets/text/TextResources";
import { ILayout } from "./types";
import { PortalFooter } from "../../footer";
import { NORNE_CENTERID } from "@portal/assets/banks";
import BankMessageDialog from "./bankMessageDialog";
import NextTopLoader from "nextjs-toploader";
import LimitedAccessMessage from "./limitedAccessMessage";
import Typography from "@portal/components/atoms/v2/typography";
import AmlStatusMessage from "./amlStatusMessage";
import PortalMessage from "./portalMessage";
import PageEnabledClientWrapper from "./pageEnabledClientWrapper";

const Layout = ({ session, children, requiresStockPageEnabled, requiresFundPageEnabled }: React.PropsWithChildren<ILayout>) => {
  return (
    <div className={`flex flex-col w-full text-defaultText bg-greyBackground min-h-[100vh]`}>
      <NextTopLoader />
      <div className="print:hidden bg-headerBackground text-headerMenuText">
        <div className="flex border-b">
          <NavBar centerId={session.centerId ?? NORNE_CENTERID} session={session} />
        </div>
      </div>
      <div className="container mx-auto mb-3 mt-3 md:mb-0">
        <AmlStatusMessage />
        <LimitedAccessMessage />
        <PortalMessage />
        {session?.status === "unauthenticated" && (
          <div className="print:hidden">
            <StatusBar>
              <Typography variant="Body">{TextResources.STATUS_BAR}</Typography>
            </StatusBar>
          </div>
        )}
        <PageEnabledClientWrapper
          session={session}
          requiresStockPageEnabled={requiresStockPageEnabled}
          requiresFundPageEnabled={requiresFundPageEnabled}
        >
          {children}
        </PageEnabledClientWrapper>
      </div>
      <PortalFooter centerId={session.centerId ?? NORNE_CENTERID} />
      <BankMessageDialog />
    </div>
  );
};

export default Layout;
